import React, { useState } from "react";
import { ToothZapFooter } from "../layouts/footer";
import { Nav } from "../layouts/header";
import "../style/faq.css";
const geoFaqs = [
  {
    question: "How do I find a ToothZap dentist near my area in New Delhi?",
    answer:
      "Use the search and area filter to browse verified ToothZap network clinics by locality, dentist name, or clinic name across New Delhi.",
  },
  {
    question:
      "Are all clinics listed on ToothZap verified for same-day crown delivery?",
    answer:
      "Yes. Every dentist shown here is a verified ToothZap network partner and each crown comes with a warranty card.",
  },
  {
    question: "Can I book directly with a clinic listed on ToothZap?",
    answer:
      "Yes. Each clinic card links directly to that dentist’s booking page so patients can book with the selected practice.",
  },
];

export const Faq: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <Nav />

      {/* FAQ SECTION */}
      <section className="container py-5">
        <div className="row">
          <div className="col-md-11 mx-auto">

     
        <h2 className="faq-title mb-3">
      Frequently Asked Questions — ToothZap <br/> Same-Day Crowns
        </h2>

        <div className="mt-4">
          {geoFaqs.map((faq, index) => (
            <details
              key={index}
              className="mb-3 p-3"
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                background: "#fff",
              }}
            >
              <summary className="faq-accordintext">
                {faq.question}
              </summary>
              <p className="mt-2 faq-accordintext-description">{faq.answer}</p>
            </details>
          ))}
        </div>
        </div>
        </div>
      </section>

      <ToothZapFooter />
    </div>
  );
};

export default Faq;